// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fR159uPwhl8hdoJ3 {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  width: 100vw;
  height: 100vh;
  background: url(https://p5.ssl.qhimg.com/t010d4bd9cdfe96e86d.png);
  background-size: cover;
  user-select: none;
}
.fR159uPwhl8hdoJ3 .YUDfXaFFVJ0ZgNGX {
  width: 1120px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .YUDfXaFFVJ0ZgNGX {
    width: 100%;
    padding: 0 16px;
  }
}
.fR159uPwhl8hdoJ3 .Gk6S_li_wUdlLKLa {
  width: 32px;
  height: 32px;
  margin-left: 40px;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .Gk6S_li_wUdlLKLa {
    margin-left: 16px;
  }
}
.fR159uPwhl8hdoJ3 .gK8htkbkqYhALdkL {
  height: 23px;
  margin-left: 8px;
}
.fR159uPwhl8hdoJ3 .M007CsGIoLOdVKrc {
  display: flex;
  align-items: center;
  padding-top: 32px;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .M007CsGIoLOdVKrc {
    padding-top: 16px;
  }
}
.fR159uPwhl8hdoJ3 .r3oJVwvhVi0MftpC {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .r3oJVwvhVi0MftpC {
    flex-direction: column;
    justify-content: center;
    height: calc(100vh - 60px);
  }
}
.fR159uPwhl8hdoJ3 .CMFLicrSbCodcr9r {
  background: url(https://p1.ssl.qhimg.com/t01b056e5cd8df30f8d.png) no-repeat;
  background-size: cover;
  width: 760px;
  height: 760px;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .CMFLicrSbCodcr9r {
    display: none;
  }
}
.fR159uPwhl8hdoJ3 .KcsBcOFybgsPE7LX {
  padding-top: 63px;
  text-align: center;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .KcsBcOFybgsPE7LX {
    padding-top: 0;
    margin-bottom: 32px;
  }
}
.fR159uPwhl8hdoJ3 .v5cPDBTpOYcAE6gM {
  color: #333333;
  font-size: 50px;
  font-weight: bold;
  line-height: 70px;
  margin-bottom: 8px;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .v5cPDBTpOYcAE6gM {
    font-size: 28px;
    line-height: 40px;
    color: #fff;
  }
}
.fR159uPwhl8hdoJ3 .P_XvT0g8eIAMZGKK {
  font-size: 16px;
  color: #333333;
  line-height: 22px;
}
@media (max-width: 768px) {
  .fR159uPwhl8hdoJ3 .P_XvT0g8eIAMZGKK {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }
}
.aBoX6dtpTWEX6TqW {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
}
.aBoX6dtpTWEX6TqW .RZWooANzUcPB3t2O {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin: 8px 8px 0 0;
  cursor: pointer;
}
.aBoX6dtpTWEX6TqW .RZWooANzUcPB3t2O:hover path {
  fill: #ccc;
}
.sce8_7eowQYV44gP {
  flex-shrink: 0;
  width: 300px;
  height: 100%;
  padding: 24px;
  background-size: 100%;
}
.AjgyTLL4bhJY5ENK {
  width: 97px;
  height: 24px;
}
.wCdtxlmxnJQJo5Xx {
  margin-top: 32px;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
}
.of-loading__container {
  z-index: 9;
}
.quc-panel-popup.quc-panel-dialog .quc-panel-close {
  top: 8px !important;
  right: 8px !important;
}
.quc-panel-popup.quc-panel-dialog .quc-panel-hd {
  padding-top: 16px !important;
}
.quc-panel-popup.quc-panel-small .quc-main {
  padding-bottom: 8px !important;
}
.quc-panel-popup.quc-wrapper .quc-form-item {
  margin-bottom: 22px !important;
}
.login-box .quc-panel {
  height: 100%;
  overflow-y: auto;
}
.login-box .quc-panel-small .quc-main {
  padding-bottom: 0;
}
@media (max-width: 768px) {
  .login-box {
    width: 100%;
  }
  .login-box .quc-body {
    left: 0 !important;
    width: 100% !important;
  }
}
@media (max-width: 768px) {
  .quc-body {
    left: 0 !important;
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/login/index.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,iEAAA;EACA,sBAAA;EACA,iBAAA;AACF;AAVA;EAYI,aAAA;EACA,cAAA;AACJ;AACI;EAAA;IACE,WAAA;IACA,eAAA;EAEJ;AACF;AApBA;EAsBI,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;AACI;EAAA;IACE,iBAAA;EAEJ;AACF;AA9BA;EAgCI,YAAA;EACA,gBAAA;AACJ;AAlCA;EAqCI,aAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;AAEI;EAAA;IACE,iBAAA;EACJ;AACF;AA5CA;EA+CI,aAAA;EACA,mBAAA;AAAJ;AAEI;EAAA;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EACJ;AACF;AAvDA;EA0DI,2EAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAAJ;AAEI;EAAA;IACE,aAAA;EACJ;AACF;AAlEA;EAqEI,iBAAA;EACA,kBAAA;AAAJ;AAEI;EAAA;IACE,cAAA;IACA,mBAAA;EACJ;AACF;AA5EA;EA+EI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AAEI;EAAA;IACE,eAAA;IACA,iBAAA;IACA,WAAA;EACJ;AACF;AA1FA;EA6FI,eAAA;EACA,cAAA;EACA,iBAAA;AAAJ;AAEI;EAAA;IACE,eAAA;IACA,+BAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AAAJ;AAPE;EAUI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAAN;AAEM;EAEI,UAAA;AADV;AAOE;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;AASE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAPJ;AAWA;EAEI,UAAA;AAVJ;AAcI;EACE,mBAAA;EACA,qBAAA;AAZN;AAeI;EACE,4BAAA;AAbN;AAgBI;EACE,8BAAA;AAdN;AAiBI;EACE,8BAAA;AAfN;AALA;EA0BM,YAAA;EACA,gBAAA;AAlBN;AATA;EA+BM,iBAAA;AAnBN;AAsBI;EAAA;IACE,WAAA;EAnBJ;EAkBE;IAII,kBAAA;IACA,sBAAA;EAnBN;AACF;AAuBE;EAAA;IAEI,kBAAA;IACA,sBAAA;EArBJ;AACF","sourcesContent":[".login {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: space-between;\n  width: 100vw;\n  height: 100vh;\n  background: url(https://p5.ssl.qhimg.com/t010d4bd9cdfe96e86d.png); \n  background-size: cover;\n  user-select: none;\n  \n  .loginInner {\n    width: 1120px;\n    margin: 0 auto;\n    \n    @media (max-width: 768px) {\n      width: 100%;\n      padding: 0 16px;\n    }\n  }\n  \n  .logo {\n    width: 32px;\n    height: 32px;\n    margin-left: 40px;\n    \n    @media (max-width: 768px) {\n      margin-left: 16px;\n    }\n  }\n  \n  .logo_text {\n    height: 23px;\n    margin-left: 8px;\n  }\n  \n  .loginHeader {\n    display: flex;\n    align-items: center;\n    padding-top: 32px;\n    \n    @media (max-width: 768px) {\n      padding-top: 16px;\n    }\n  }\n  \n  .loginCenter {\n    display: flex;\n    align-items: center;\n    \n    @media (max-width: 768px) {\n      flex-direction: column;\n      justify-content: center;\n      height: calc(100vh - 60px);\n    }\n  }\n  \n  .loginBanner {\n    background: url(https://p1.ssl.qhimg.com/t01b056e5cd8df30f8d.png) no-repeat;\n    background-size: cover;\n    width: 760px;\n    height: 760px;\n    \n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n  \n  .loginDesc {\n    padding-top: 63px;\n    text-align: center;\n    \n    @media (max-width: 768px) {\n      padding-top: 0;\n      margin-bottom: 32px;\n    }\n  }\n  \n  .mainTitle {\n    color: #333333;\n    font-size: 50px;\n    font-weight: bold;\n    line-height: 70px;\n    margin-bottom: 8px;\n    \n    @media (max-width: 768px) {\n      font-size: 28px;\n      line-height: 40px;\n      color: #fff;\n    }\n  }\n  \n  .subTitle {\n    font-size: 16px;\n    color: #333333;\n    line-height: 22px;\n    \n    @media (max-width: 768px) {\n      font-size: 14px;\n      color: rgba(255, 255, 255, 0.8);\n    }\n  }\n  \n  &-header {\n    display: flex;\n    justify-content: flex-end;\n    position: absolute;\n    z-index: 3;\n    top: 0;\n    left: 0;\n    right: 0;\n\n    .close {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 24px;\n      height: 24px;\n      margin: 8px 8px 0 0;\n      cursor: pointer;\n\n      &:hover {\n        path {\n          fill: #ccc;\n        }\n      }\n    }\n  }\n\n  &-banner {\n    flex-shrink: 0;\n    width: 300px;\n    height: 100%;\n    padding: 24px;\n    background-size: 100%;\n  }\n\n  &-logo {\n    width: 97px;\n    height: 24px;\n  }\n\n  &-desc {\n    margin-top: 32px;\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 30px;\n    color: #fff;\n  }\n}\n\n:global {\n  .of-loading__container {\n    z-index: 9;\n  }\n\n  .quc-panel-popup {\n    &.quc-panel-dialog .quc-panel-close {\n      top: 8px !important;\n      right: 8px !important;\n    }\n\n    &.quc-panel-dialog .quc-panel-hd {\n      padding-top: 16px !important;\n    }\n\n    &.quc-panel-small .quc-main {\n      padding-bottom: 8px !important;\n    }\n\n    &.quc-wrapper .quc-form-item {\n      margin-bottom: 22px !important;\n    }\n  }\n\n  .login-box {\n    .quc-panel {\n      height: 100%;\n      overflow-y: auto;\n    }\n\n    .quc-panel-small .quc-main {\n      padding-bottom: 0;\n    }\n    \n    @media (max-width: 768px) {\n      width: 100%;\n      \n      .quc-body {\n        left: 0 !important;\n        width: 100% !important;\n      }\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .quc-body {\n      left: 0 !important;\n      width: 100% !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `fR159uPwhl8hdoJ3`,
	"loginInner": `YUDfXaFFVJ0ZgNGX`,
	"logo": `Gk6S_li_wUdlLKLa`,
	"logo_text": `gK8htkbkqYhALdkL`,
	"loginHeader": `M007CsGIoLOdVKrc`,
	"loginCenter": `r3oJVwvhVi0MftpC`,
	"loginBanner": `CMFLicrSbCodcr9r`,
	"loginDesc": `KcsBcOFybgsPE7LX`,
	"mainTitle": `v5cPDBTpOYcAE6gM`,
	"subTitle": `P_XvT0g8eIAMZGKK`,
	"login-header": `aBoX6dtpTWEX6TqW`,
	"close": `RZWooANzUcPB3t2O`,
	"login-banner": `sce8_7eowQYV44gP`,
	"login-logo": `AjgyTLL4bhJY5ENK`,
	"login-desc": `wCdtxlmxnJQJo5Xx`
};
export default ___CSS_LOADER_EXPORT___;
